import React, { useEffect, useRef, useState } from 'react';

export default function ShareToastHost() {
  const [message, setMessage] = useState('');
  const timerRef = useRef(null);

  useEffect(() => {
    function handleToast(event) {
      const nextMessage = String(event.detail?.message || '').trim();
      if (!nextMessage) return;
      window.clearTimeout(timerRef.current);
      setMessage(nextMessage);
      timerRef.current = window.setTimeout(() => setMessage(''), 2200);
    }

    window.addEventListener('od:share-toast', handleToast);
    return () => {
      window.clearTimeout(timerRef.current);
      window.removeEventListener('od:share-toast', handleToast);
    };
  }, []);

  return message ? <div className="ct-toast ct-share-toast" role="status">{message}</div> : null;
}
